import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog"
import { buttonVariants } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export const AlertDialog = AlertDialogPrimitive.Root

export const AlertDialogTrigger = AlertDialogPrimitive.Trigger

const AlertDialogPortal = AlertDialogPrimitive.Portal

type AlertDialogOverlayProps = React.ComponentPropsWithRef<typeof AlertDialogPrimitive.Overlay>
export const AlertDialogOverlay = ({ className, ref, ...props }: AlertDialogOverlayProps) => (
  <AlertDialogPrimitive.Overlay
    className={cn(
      "bg-on-backdrop data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50",
      className,
    )}
    ref={ref}
    {...props}
  />
)

type AlertDialogContentProps = React.ComponentPropsWithRef<typeof AlertDialogPrimitive.Content>
export const AlertDialogContent = ({ className, ref, ...props }: AlertDialogContentProps) => (
  <AlertDialogPortal>
    <AlertDialogOverlay />
    <AlertDialogPrimitive.Content
      ref={ref}
      className={cn(
        "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[state=closed]:slide-out-to-left-1/2 data-[state=closed]:slide-out-to-top-[48%] data-[state=open]:slide-in-from-left-1/2 data-[state=open]:slide-in-from-top-[48%] translate-x-custom translate-y-custom fixed top-[50%] left-[50%] z-50 grid w-full max-w-sm gap-4 border p-6 shadow-lg duration-200 sm:rounded-md md:w-full",
        className,
      )}
      {...props}
    />
  </AlertDialogPortal>
)

export const AlertDialogHeader = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("flex flex-col space-y-2 text-center sm:text-left", className)} {...props} />
)

export const AlertDialogFooter = ({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) => (
  <div className={cn("flex flex-col-reverse sm:flex-row sm:justify-end sm:space-x-2", className)} {...props} />
)

type AlertDialogTitleProps = React.ComponentPropsWithRef<typeof AlertDialogPrimitive.Title>
export const AlertDialogTitle = ({ className, ref, ...props }: AlertDialogTitleProps) => (
  <AlertDialogPrimitive.Title ref={ref} className={cn("text-lg font-semibold", className)} {...props} />
)

type AlertDialogDescriptionProps = React.ComponentPropsWithRef<typeof AlertDialogPrimitive.Description>
export const AlertDialogDescription = ({ className, ref, ...props }: AlertDialogDescriptionProps) => (
  <AlertDialogPrimitive.Description ref={ref} className={cn("text-muted-foreground text-sm", className)} {...props} />
)

type AlertDialogActionProps = React.ComponentPropsWithRef<typeof AlertDialogPrimitive.Action>
export const AlertDialogAction = ({ className, ref, ...props }: AlertDialogActionProps) => (
  <AlertDialogPrimitive.Action ref={ref} className={cn(buttonVariants(), className)} {...props} />
)

type AlertDialogCancelProps = React.ComponentPropsWithRef<typeof AlertDialogPrimitive.Action>
export const AlertDialogCancel = ({ className, ref, ...props }: AlertDialogCancelProps) => (
  <AlertDialogPrimitive.Cancel
    ref={ref}
    className={cn(buttonVariants({ variant: "secondary" }), "mt-2 sm:mt-0", className)}
    {...props}
  />
)
